import { FC, useState } from "react";

import { message, Spin } from "antd";

import { useIntl } from "react-intl";
import { getLocation, updateLocationLink } from "../../../network/location";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { useSelector } from "react-redux";
import CatalogDirectLink from "./CatalogDirectLink";
import ServicesDirectLink from "./ServicesDirectLink";
import DirectLinksSkeleton from "./modal-wrappers/DirectLinksSkeleton";

interface DirectLinksProps {}

const DirectLinks: FC<DirectLinksProps> = ({}) => {
  const [catalogModal, setCatalogModal] = useState(false);

  const [servicesModal, setServicesModal] = useState(false);
  const [memberShipModal, setMemberShipModal] = useState(false);
  const intl = useIntl();
  const queryClient = useQueryClient();
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number | null } }) => state.calendar
  );

  const { data: locationLinksData, isLoading: isFetchingLocation } = useQuery(
    [queryKeys.Locations, locationId],
    () => getLocation(locationId),
    {
      enabled: !!locationId,
      select: (res) => res?.data,
    }
  );

  const { mutate: onUpdateLocationLink, isLoading } = useMutation(
    (body) => updateLocationLink(locationId, body),
    {
      onSuccess: (res: any) => {
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          queryClient.invalidateQueries([queryKeys.Locations, locationId]);
          // if (res?.data?.data?.have_catalog_link) {
          //   setCatalogModal(true);
          // }
        }
      },
      onError: (error) => {
        console.log("Add Category error:", error);
        message.error("حاول مرة اخرى");
      },
    }
  );

  const handleCreateLink = async (params: any) => {
    onUpdateLocationLink({
      ...params,
    });
    if (params?.link_type === "catalog_link") {
      setCatalogModal(true);
    }
    if (params?.link_type === "membership_link") {
      setMemberShipModal(true);
    }
    if (params?.link_type === "service_link") {
      setServicesModal(true);
    }
  };

  const handleRemoveLink = async (params: any) => {
    onUpdateLocationLink({
      ...params,
    });
  };

  return (
    <div className="py-12 px-8 bg-[#EEF0FF] space-y-3">
      <div className="space-y-3">
        <h2 className="text-2xl text-color-primary">
          {intl.formatMessage({ id: "share_different_ways" })}
        </h2>
        <p className="text-[#75757E]">
          {intl.formatMessage({ id: "create_booking_links" })}
        </p>
      </div>
      <Spin spinning={isLoading}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3   gap-6 w-full">
          {isFetchingLocation ? (
            <DirectLinksSkeleton />
          ) : (
            <CatalogDirectLink
              locationLinksData={locationLinksData}
              isLoading={isLoading}
              handleRemoveLink={handleRemoveLink}
              handleCreateLink={handleCreateLink}
              catalogModal={catalogModal}
              setCatalogModal={setCatalogModal}
            />
          )}
          {isFetchingLocation ? (
            <DirectLinksSkeleton />
          ) : (
            <ServicesDirectLink
              locationLinksData={locationLinksData}
              isLoading={isLoading}
              handleRemoveLink={handleRemoveLink}
              handleCreateLink={handleCreateLink}
              servicesModal={servicesModal}
              setServicesModal={setServicesModal}
              setCatalogModal={setCatalogModal}
            />
          )}
          {/* {isFetchingLocation ? (
            <DirectLinksSkeleton />
          ) : (
            <MembershipsDirectLink
              locationLinksData={locationLinksData}
              isLoading={isLoading}
              handleRemoveLink={handleRemoveLink}
              handleCreateLink={handleCreateLink}
              memberShipModal={memberShipModal}
              setMemberShipModal={setMemberShipModal}
            />
          )} */}
        </div>
      </Spin>
    </div>
  );
};

export default DirectLinks;
